module.exports = __webpack_public_path__ + "img/exam-stat-subjects@1.5x.250b3671.png";